"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireWildcard(require("react"));

var _history = require("history");

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function useHistory() {
  var ref = (0, _react.useRef)((0, _history.createBrowserHistory)());
  return ref['current'];
}

function NotFount() {
  try {
    var handleClickLink = function handleClickLink() {
      history.back();
    };

    var history = useHistory();
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['code']
    }, "404"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['info']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['big']
    }, "\u041E\u0419"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['header']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 3
    }, "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A")), /*#__PURE__*/_react["default"].createElement(_storybook.Text, null, "\u041A\u0430\u0436\u0435\u0442\u0441\u044F, \u0443 \u043D\u0430\u0441 \u043D\u0435\u0442 \u0442\u0430\u043A\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B.", /*#__PURE__*/_react["default"].createElement("br", null), "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0441\u0441\u044B\u043B\u043A\u0443 \u0438\u043B\u0438 \u0432\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C ", /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['link'],
      onClick: handleClickLink
    }, "\u043A \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0435\u043C\u0443 \u0440\u0430\u0437\u0434\u0435\u043B\u0443")))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = NotFount;
exports["default"] = _default;